import {
  Y1731ConfigFieldMapping as ConfigFieldMapping,
  DEFAULT_FLOWS,
  ETHER_TYPE_LABEL,
  vlanConfigLabel,
  vlanConfigValue
} from '../models/models';

export const Y1731_AGENT_MODEL_CONFIG = {
  id: 'y1731_test',
  agentConfig: {
    default: {
      setup: {
        //setup page model
        alias: {
          enabled: true,
          value: 'Y1731',
          outputField: ConfigFieldMapping.ALIAS,
          tabId: 'y1731_setup',
          restoreOnAgentChange: true
        },
        customer: {
          enabled: true,
          value: '',
          outputField: 'customer',
          tabId: 'y1731_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        technician: {
          enabled: true,
          value: '',
          outputField: 'technician',
          tabId: 'y1731_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        contact: {
          enabled: true,
          value: '',
          outputField: 'contact',
          tabId: 'y1731_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        email: {
          enabled: true,
          value: '',
          outputField: 'email',
          tabId: 'y1731_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        phone: {
          enabled: true,
          value: '',
          outputField: 'phone',
          tabId: 'y1731_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        technicianId: {
          enabled: true,
          value: '',
          outputField: 'technicianId',
          tabId: 'y1731_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        comments: {
          enabled: true,
          value: '',
          outputField: 'comments',
          tabId: 'y1731_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        runType: {
          enabled: true,
          value: 'on-going',
          outputField: ConfigFieldMapping.RUN_TYPE,
          tabId: 'y1731_setup',
          restoreOnAgentChange: true
        },
        agentType: {
          enabled: true,
          value: 'default',
          outputField: ConfigFieldMapping.AGENT_TYPE,
          tabId: 'y1731_setup'
        },
        selectedOriginator: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SELECTED_ORIGINATOR,
          tabId: 'y1731_setup',
          restoreOnAgentChange: true
        },
        srcMACAddress: {
          enabled: true,
          value: '00:11:22:33:44:55',
          outputField: ConfigFieldMapping.SRC_MAC_ADDRESS,
          lookup: ["capabilities.phy['test-mac-address']"],
          tabId: 'y1731_setup'
        },
        mepId: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.MEP_ID,
          tabId: 'y1731_setup',
          outputOptional: true
        },
        pmReportInterval: {
          enabled: true,
          value: 300,
          outputField: ConfigFieldMapping.PM_REPORT_INTERVAL,
          tabId: 'y1731_setup'
        },
        persistAfterReboot: {
          enabled: true,
          value: false,
          outputField: ConfigFieldMapping.PERSIST_AFTER_REBOOT,
          tabId: 'y1731_setup'
        },
        vlanConfig: {
          enabled: true,
          value: vlanConfigValue.UNTAGGED,
          outputField: ConfigFieldMapping.VLAN_CONFIG,
          options: {
            type: 'dropdown',
            value: [
              { name: vlanConfigLabel.UNTAGGED, value: vlanConfigValue.UNTAGGED },
              { name: vlanConfigLabel.SINGLE_VLAN, value: vlanConfigValue.SINGLE_VLAN },
              { name: vlanConfigLabel.Q_IN_Q, value: vlanConfigValue.Q_IN_Q }
            ]
          },
          tabId: 'y1731_setup'
        },
        vlanId: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SVLAN_ID,
          tabId: 'y1731_setup',
          outputOptional: true
        },
        vlanPriority: {
          enabled: true,
          value: 0,
          outputField: ConfigFieldMapping.SVLAN_PRIORITY,
          tabId: 'y1731_setup',
          outputOptional: true
        },
        cvlanId: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.CVLAN_ID,
          tabId: 'y1731_setup',
          outputOptional: true
        },
        cvlanPriority: {
          enabled: true,
          value: 0,
          outputField: ConfigFieldMapping.CVLAN_PRIORITY,
          tabId: 'y1731_setup',
          outputOptional: true
        },
        cvlanEthertype: {
          enabled: true,
          value: ETHER_TYPE_LABEL.ETHER_88a8,
          outputField: ConfigFieldMapping.CVLAN_ETHER_TYPE,
          tabId: 'y1731_setup',
          outputOptional: true
        },
        flows: {
          enabled: true,
          value: DEFAULT_FLOWS,
          outputField: ConfigFieldMapping.FLOWS,
          tabId: 'y1731_flows',
          outputOptional: true
        },
        destinationMac: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.DESTINATION_MAC,
          tabId: 'y1731_flows'
        },
        flowId: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.FLOW_ID,
          tabId: 'y1731_flows'
        }
      },

      running: {
        add: 'anything that is different between agents in running view'
      },

      final: {
        add: 'anything that is different between agents in final report'
      }
    }
  }
};
